export const AddIndustryTypeFormData = [
    {
        label: "Industry Type",
        // name: "assistantType",
        name: "industryType",
        rules: [
            {
                required: true,
                message: 'Please Input Industry Type!',
            },
        ]
    }
];